<template>
    <v-card max-width="500">
        <v-form
            ref="userForm"
            v-model="isValid"
        >
            <v-card-text>
                <v-container
                    class="pb-0"
                    fluid
                >
                    <v-row class="pb-0">
                        <v-col
                            class="pt-0"
                            cols="12"
                        >
                            <image-uploader
                                :disabled="isLoading"
                                :image-in="user.image"
                                @imageDone="imageDone"
                                @imageProcessing="imageProcessing"
                                height="185"
                                max-image-height="500"
                                max-image-width="500"
                                width="300"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            lg="6"
                        >
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[requiredRule]"
                                autocomplete="given-name"
                                label="Name"
                                v-model="user.name"
                            ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            lg="6"
                        >
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[requiredRule]"
                                autocomplete="family-name"
                                label="Surname"
                                v-model="user.surname"
                            ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            lg="6"
                        >
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[requiredRule/*,emailRule*/]"
                                autocomplete="email"
                                label="Email"
                                v-model="user.email"
                            ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            lg="6"
                        >
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[requiredRule]"
                                autocomplete="tel"
                                label="Cell"
                                v-model="user.cellNumber"
                            ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            lg="6"
                        >
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[requiredRule]"
                                label="ID"
                                v-model="user.idNumber"
                            ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            lg="6"
                        >
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[requiredRule,lengthRule(15)]"
                                autocomplete="username"
                                label="Username"
                                v-model="user.username"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                :disabled="isLoading || ('roleType' in user && user.roleType == 1 && roleTypes.find(x => x.key == 1) && 'disabled' in roleTypes.find(x => x.key == 1))"
                                :items="roleTypes"
                                :rules="[requiredRule]"
                                @input="$refs.userForm.validate()"
                                item-text="value"
                                item-value="key"
                                label="Role Type"
                                v-model="user.roleType"
                            ></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                            :disabled="isLoading"
                            :items="companies"
                            item-text="value"
                            item-value="key"
                            label="Select Company"
                            v-model="companyId" 
                            
                        ></v-select>
                        </v-col>
                        <v-col
                            cols="12"
                            v-show="canHaveAreas"
                        >
                            <v-switch
                                class="mb-0"
                                label="All Areas"
                                v-model="user.allAreas"
                            ></v-switch>
                        </v-col>
                        <v-col
                            cols="12"
                            v-show="!user.allAreas && canHaveAreas"
                        >
                            <v-autocomplete
                                :disabled="isLoading"
                                :items="areas"
                                chips
                                deletable-chips
                                item-text="value"
                                item-value="key"
                                label="Areas"
                                multiple
                                v-model="user.areaIds"
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="12">
                            <v-switch
                                class="mb-0"
                                label="All Providers"
                                v-model="user.allProviders"
                            ></v-switch>
                        </v-col>
                        <v-col
                            cols="12"
                            v-show="!user.allProviders"
                        >
                            <v-autocomplete
                                :disabled="isLoading"
                                :items="providers"
                                chips
                                clearable
                                deletable-chips
                                item-text="value"
                                item-value="key"
                                label="Providers"
                                multiple
                                v-model="user.providerIds"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <v-switch
                                class="mb-0"
                                label="Recieve new Incident notifications"
                                v-model="user.incidentSubscribed"
                            ></v-switch>
                        </v-col>
                        <v-col cols="12">
                            <v-switch
                                class="mb-0"
                                label="Recieve Patient authorization requests"
                                v-model="user.patientAuthorizer"
                            ></v-switch>
                        </v-col>
                        <v-col cols="12">
                            <v-switch
                                class="mb-0"
                                label="Recieve Incident authorization requests"
                                v-model="user.incidentAuthorizer"
                            ></v-switch>
                        </v-col>
                        <v-col
                            cols="12"
                            lg="6"
                        >
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[]"
                                label="Accisure Commission Rate"
                                min="0"
                                type="number"
                                v-model.number="
                                                user.accisureCommissionRate
                                            "
                                v-show="user.roleType == roleType.AccisureRep"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                        <v-col no-gutters>
                            <v-btn
                                :disabled="isLoading && !isDeleting"
                                :loading="isDeleting"
                                @click="deleteEntity"
                                class="text-none"
                                color="warning darken-1"
                                text
                                v-show="user.id > 0"
                            >Delete</v-btn>
                            <v-btn
                                :disabled="isLoading && !isResetting"
                                :loading="isResetting"
                                @click="resetPassword"
                                class="text-none"
                                color="secondary darken-1"
                                text
                                v-show="user.id > 0"
                            >Reset Password</v-btn>
                        </v-col>
                        <v-col
                            align-self="end"
                            class="text-right"
                            justify="end"
                            no-gutters
                        >
                            <v-btn
                                :disabled="isLoading"
                                @click="closeForm"
                                class="text-none"
                                color="secondary darken-1"
                                text
                            >Close</v-btn>
                            <v-btn
                                :disabled="isLoading && !isSaving"
                                :loading="isSaving"
                                @click="saveEntity"
                                class="text-none"
                                color="secondary darken-1"
                                text
                            >{{user.id > 0 ? "Update" : "Add"}}</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
import imageUploader from "../ImageUploader";
import User from "../../models/User.model";
import RoleType from "../../constants/RoleType.constant";
export default {
    props: {
        userIn: User
    },
    components: {
        imageUploader
    },

   

created: async function() {
    this.companies = await this.$store.dispatch("companies/getlist");
    if (this.user && this.user.companyId) {
        this.companyId = this.user.companyId;
    }
    },

    mounted: async function() {
        this.roleTypes = await this.$store.dispatch("authentication/getRoles");
        this.providers = await this.$store.dispatch("providers/getlist");
        this.areas = await this.$store.dispatch("areas/getlist");

    },
    data() {
    return {
        roleTypes: [],
        companies: [],
        companyId: null, 
        providers: [],
        areas: [],
        user: new User().set(this.userIn),
        isValid: null,
        isLoading: null,
        isSaving: null,
        isDeleting: null,
        isResetting: null,
        notifyShow: null,
        notifyMessage: null,
        notifyColor: null,
        requiredRule: v => !!v || "required",
        lengthRule: limit => v =>
            !v || v.length <= limit || "exceeds " + limit + " characters",
        emailRule: v => /[.\w]+@[.\w]+$/.test(v) || "invalid email",
        roleType: RoleType
    };
},
    computed: {
        canHaveAreas: function() {
            return this.user.roleType != this.roleType.ServiceProviderUser;
        }
    },
    methods: {
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedUser) {
            this.$emit("saved", savedUser);
        },
        emitDeletedEntity(deletedUser) {
            this.$emit("deleted", deletedUser);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        async fetchCompanies() {
    try {
        
        const response = await this.$axios.get('/companies/getlist');
        if (Array.isArray(response.data) && response.data.length > 0) {
            return response.data.map(company => ({
                key: company.id,
                value: company.name
            }));
        } else {
            return [];
        }
    } catch (error) {
        return [];
    }
},
        
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.userForm.validate();
            return this.isValid;
        },
        //save      ------------------------------------------------------------
        saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;
                this.user.roles = [this.user.roleType];
                this.user.companyId = this.companyId;

                if (!this.canHaveAreas) {
                    this.user.allAreas = false;

                    if(this.user.areaIds)
                    this.user.areaIds.splice(0, this.user.areaIds.length);
                    else
                    this.user.areaIds = [];
                
                }
                this.$store
                    .dispatch(
                        "users/" +
                            (this.user.id == 0 ? "addUser" : "updateUser"),
                        this.user
                    )
                    .then(
                        user => {
                            this.notify("User successfully saved.", "success");
                            if (this.user.id == 0) {
                                this.user.id = user.id;
                            }
                            user.roleType =
                                user.roles && user.roles.length > 0
                                    ? user.roles[0]
                                    : null;
                            this.emitSavedEntity(user);
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this user profile?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("users/deleteUser", this.user)
                    .then(
                        () => {
                            this.notify(
                                "User successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.user);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        },
        //reset password     ------------------------------------------------------------
        resetPassword() {
            var isConfirmed = confirm(
                "Are you sure you want to reset this account password? A new password will be emailed to the account."
            );
            if (isConfirmed) {
                this.isResetting = true;
                this.isLoading = true;
                this.$store
                    .dispatch("users/resetPassword", this.user.id)
                    .then(
                        () =>
                            this.notify(
                                "Password was reset and will be emailed to user profile email.",
                                "success"
                            ),
                        error => this.notify(error, "error")
                    )
                    .finally(this.resetPasswordDone);
            }
        },
        resetPasswordDone() {
            this.isLoading = false;
            this.isResetting = false;
        },
        //image     ------------------------------------------------------------
        imageProcessing() {
            this.isLoading = true;
        },
        imageDone(image) {
            this.user.image = image;
            this.isLoading = false;
        }
    }
};
</script>

<style lang="stylus" scoped></style>
